import SeoHead from '../../components/SeoHead';
import { Collection } from "@sourceflow-uk/sourceflow-sdk"
import React from 'react';
import {
    Container,
    Row,
    Col
} from 'reactstrap';
import Link from 'next/link';
import SubBanner from '../../components/SubBanner';
import BlogDetail from '../../components/BlogDetail';
import AllBlogs from '../../components/AllBlogs';
import urlSlug from "url-slug";
import Header from '../../components/MainHeader';

export default function NewsPage({
    news,
    all_consultants,
    all_blogs
}) {
    return (
        <>
            <SeoHead
                // site_name={`Driving Force`}
                page_name={`${news.title}`}
                // description={``}
                canonical_link={`/employers-news/${news.url_slug}/`}
                og_image={`${news.image}`}
            />
            <Header />
            <SubBanner
                global={global}
                pathPrefix={`employers_blog_page.sub_banner`}
                news={news}
                customClass={`mb-5 primary-banner`}
                buttonTitle={`Employers / News and insights`}
                buttonLink={`/employers-news/`}
                post={news}
                all_consultants={all_consultants}

            />
            <BlogDetail
                global={global}
                news={news}
                pathPrefix={`employers_blog_page.blog_detail`}
            />
            <AllBlogs
                global={global}
                pathPrefix={`employers_blog_page.all_blogs`}
                all_blogs={all_blogs}
                customClass={`other-blogs mt-5 pt-5 mb-5 pb-5`}
                buttonTitle={`Read`}
                heading={`Recent articles`}
                pagePrefix={`employers-news`}
            />
        </>
    );
}

export async function getStaticProps({ params }) {
    const news = (await Collection('news')).getJsonItem(params.url_slug, 'url_slug');

    // Checks consultant news author if matches
    const lowerCaseBlogAuthor = news.author.toLowerCase();
    const author_url_slug = urlSlug(lowerCaseBlogAuthor);

    let all_consultants = [];
    if (news.author !== undefined) {
        // Match consultant name
        const consultants = (await Collection("consultants")).filter(function (i) {
            return urlSlug(i.url_slug) === author_url_slug;
        });
        if (consultants.items.length > 0) {
            all_consultants = consultants.orderBy("order").getJsonItem();
        }
    } else {
        all_consultants = [];
    }

    const employer_tag = "Employer";
    const blogs = (await Collection("news"))
        .filter(function (post) {
            return (
                post.tag?.en.includes(employer_tag)
            );
        }).filter(function (post) {
            return (
                // Checks that so no identical blog will appear on the blog page
                post.url_slug !== news.url_slug
            )
        })


    const all_blogs = blogs.orderBy('published_date').getItems().slice(0, 3);

    return {
        props: {
            news,
            all_consultants,
            all_blogs
        },
    }
}

export async function getStaticPaths() {
    const newsPaths = (await Collection('news')).getPaths('url_slug');
    return {
        paths: newsPaths,
        fallback: false
    }
}